"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AboutHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.1;
  return <section id="about-hero" ref={ref} className="relative min-h-screen w-full overflow-hidden flex items-center justify-center !h-[700px] !bg-[url('https://newmavericks.com/img/manhattan_skyline_hero_background.png')] !bg-[url(https://newmavericks.com/wp-content/uploads/2026/03/manhattan_skyline_daytime_water.webp)] ![margin:100px_0px_100px_0px]">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('https://newmavericks.com/img/manhattan_skyline_hero_background.png')]" style={{
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }}>
        {}
      </div>

      {}
      <div className={`
          relative z-10 max-w-4xl mx-auto px-6 text-center
          ${isVisible ? "animate-fade-in-up" : "opacity-0"}
        `}>
        <h1 className="font-display font-bold text-white !w-[900px] !text-[40px] ![margin:-20px_0px_30px_-10px]">Globally Trusted CEO Breakthrough <br />Protection Partners to CEO Leaders&nbsp;</h1>

        <div className="mb-8 w-full max-w-3xl mx-auto overflow-hidden rounded-lg shadow-strong">
          <div className="aspect-video">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/y7IUPV6YkRk?rel=0&modestbranding=1" title="New Mavericks CEO Development" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>

        <div className="flex justify-center">
          <Link to="https://calendly.com/newmavericks/15" newTab>
            <Button className="text-sm font-medium h-9 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs px-4 py-2 has-[>svg]:px-3 btn-primary !w-[200px] !h-[50px] !font-bold !text-2xl !bg-[hsl(142,69%,58%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Schedule Call</Button>
          </Link>
        </div>

      </div>
    </section>;
}